import { createFileRoute } from '@tanstack/react-router';

// `/comms/unsorted` — the command-lane "prihozhaya" (Agent U3, spec 07 §5).
// No search params; the whole Comm Center mounts only behind env.VITE_COMM_CENTER
// via the parent `/comms` route (Agent U1).
export const Route = createFileRoute('/_authenticated/comms/unsorted')({});
